import styled from 'styled-components';

// SidebarCard has been replaced with shared Card component with sticky positioning

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const SidebarTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
`;

export const HelpButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  transition: color 0.15s ease;

  &:hover {
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

export const SegmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SegmentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(0, 0, 0, 0.04)'};
  border-radius: 6px;
  transition: all 0.15s ease;
  cursor: pointer;

  &:hover {
    transform: translateX(4px);
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};
  }
`;

export const SegmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SegmentLabel = styled.div`
  font-weight: 600;
  color: ${(props) =>
    props.color ||
    (props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack)};
  font-size: 14px;
`;

export const SegmentDescription = styled.div`
  font-size: 12px;
  color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748b')};
`;

export const SegmentCount = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) =>
    props.color ||
    (props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack)};
`;

// Custom right-sliding drawer for education
export const EducationDrawer = styled.div`
  height: 100%;
  background: ${(props) => (props.theme.name === 'dark' ? '#1e293b' : 'white')};
  box-shadow: -1px 0px 7px rgba(0, 0, 0, 0.5);
  border: 1px solid
    ${(props) => (props.theme.name === 'dark' ? '#334155' : '#e6e6e6')};
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 200;
  transform: ${(props) =>
    props.isVisible ? 'translateX(0%)' : 'translateX(100%)'};
  transition: transform 0.3s ease-out;
  overflow-y: auto;

  @media (min-width: 860px) {
    width: 520px;
  }

  @media (max-width: 860px) {
    height: calc(100% - 60px);
    top: 60px;
  }
`;

export const DrawerOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  display: ${(props) => (props.isVisible ? 'block' : 'none')};
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid
    ${(props) => (props.theme.name === 'dark' ? '#334155' : '#e5e7eb')};
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
`;

export const DrawerCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  transition: color 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const DrawerContent = styled.div`
  padding: 24px;
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#334155')};
`;

export const ProTipCard = styled.div`
  margin-top: 32px;
  padding: 20px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.03)'};
  border-radius: 12px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};
  position: relative;
`;

export const ProTipHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

export const ProTipIconBox = styled.div`
  width: 32px;
  height: 32px;
  background: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ProTipTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.9)'
      : props.theme.colors.blueBlack};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ProTipText = styled.p`
  margin: 0 0 12px 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.7)' : '#475569'};
`;
